/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  global-require,
  import/no-extraneous-dependencies
*/
import React from 'react';
import { IntlProvider, injectIntl } from 'react-intl';
import deepExtend from 'lodash/object/merge';
import flattenMessages from 'common/utils/flatten-messages';

let defaultMessages;
const getDefaultMessages = () => {
  if (defaultMessages == null) {
    defaultMessages = flattenMessages(deepExtend(
      require('signer/translations/en-US.json'),
      require('ui/signature-modal/translations/en-US.json'),
      require('hellospa/components/editor/translations/en-US.json'),
    ));
  }
  return defaultMessages;
};

const makeComponentIntl = (component) => {
  const InjectedComponent = injectIntl(component);

  // Needs to be a class because refs are added by React Intl
  class IntlComponent extends React.Component {
    render() {
      const intlMessages = this.props.intl ? flattenMessages(this.props.intl.messages) : null;
      const messages = this.props.messages || intlMessages || getDefaultMessages();

      return <IntlProvider locale='en-US' messages={messages}>
        <InjectedComponent {...this.props} />
      </IntlProvider>;
    }
  }

  return IntlComponent;
};

export default makeComponentIntl;
module.exports = makeComponentIntl;
